import "../instrument";
import * as Sentry from "@sentry/react";
import { BrowserRouter, Route, Routes } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ErrorFallback } from "@/components";
import { AppLayout, RootLayout } from "@/layouts";
import {
  AcceptInvitationPage,
  CatchAllPage,
  CompanyProfilePage,
  DashboardPage,
  JobCreatePage,
  JobPage,
  JobPipelinePage,
  JobsPage,
  SettingsPage,
  SignInPage,
} from "@/pages";

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const errorFallback = ({ resetError }: { resetError: () => void }) => (
  <ErrorFallback resetError={resetError} />
);

// * Please ensure that the `routes` util is updated as new routes are added here.

function App() {
  return (
    <Sentry.ErrorBoundary fallback={errorFallback}>
      <QueryClientProvider
        client={queryClient}
        // TODO: Is this the best place to put the `<QueryClientProvider>`?
      >
        <BrowserRouter>
          <Routes>
            <Route element={<RootLayout />}>
              <Route
                path="accept-invitation"
                element={<AcceptInvitationPage />}
              />
              <Route path="sign-in" element={<SignInPage />} />
              <Route path="companies/:companyId" element={<AppLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="jobs">
                  <Route index element={<JobsPage />} />
                  <Route path="create" element={<JobCreatePage />} />
                  <Route path=":jobId">
                    <Route index element={<JobPage />} />
                    <Route path="pipeline" element={<JobPipelinePage />} />
                  </Route>
                </Route>
                <Route path="profile" element={<CompanyProfilePage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<CatchAllPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
